import React, { ReactElement } from 'react'
import Carousel from '@/components/molecules/Carousel/Carousel'
import getCloudinaryUrl from '@/utils/getCloudinaryUrl'

const cloudinaryImageOptions = 'q_25,w_240,ar_4:3,c_fill'

export const locations = [
  {
    title: 'California',
    subtitle: '750+ Treatment Centers',
    color: '',
    link: '/california/',
    backgroundImage: getCloudinaryUrl(
      '/v1529431328/assets/location-california.jpg',
      cloudinaryImageOptions
    )
  },
  {
    title: 'Florida',
    subtitle: '250+ Treatment Centers',
    color: '',
    link: '/florida/',
    backgroundImage: getCloudinaryUrl(
      '/v1536062370/florida-thumb.png',
      cloudinaryImageOptions
    )
  },
  {
    title: 'Texas',
    subtitle: '200+ Treatment Centers',
    color: 'bg-[#EFFFDF]',
    link: '/texas/',
    backgroundImage: getCloudinaryUrl(
      '/d1lwtfrjjozuafz5gr9d.jpg',
      cloudinaryImageOptions
    )
  },
  {
    title: 'Arizona',
    subtitle: '100+ Treatment Centers',
    color: '',
    link: '/arizona/',
    backgroundImage: getCloudinaryUrl(
      '/jrfgwbgjvb21qvhzsttu.jpg',
      cloudinaryImageOptions
    )
  },
  {
    title: 'New York',
    subtitle: '50+ Treatment Centers',
    color: '',
    link: '/new-york/',
    backgroundImage: getCloudinaryUrl(
      '/v55lewxmz8fkmqzzbliw.jpg',
      cloudinaryImageOptions
    )
  }
]

const LocationsCarousel = (): ReactElement => {
  return (
    <Carousel
      title="Find the Right Location"
      subtitle="Explore addiction treatment options anywhere."
      items={locations}
      viewAllLink="/locations/"
      viewAllLabel="All Locations"
    />
  )
}

export default LocationsCarousel
